import NotLoggedInView from './NotLoggedInView';

export default NotLoggedInView;
